import React from "react";

export default function APIDataFetchLoader() {
  return (
    // <div id="loader">
    //   <div className="lds-hourglass"></div>
    // </div>

    <div className="preloader">
      <div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
}
